import { h } from "preact";

import styles from "./ContinueWithEmailButton.module.css";

interface Props {
    onClick?: (event: Event) => void;
}

function ContinueWithEmailButton({ onClick }: Props) {
    return (
        <button
            class={styles.continueWithEmailButton}
            tabIndex={0}
            onClick={onClick}>
            <span class={styles.continueWithEmailButtonText}>
                Continue with Email
            </span>
        </button>
    );
}

export default ContinueWithEmailButton;
